import { Dispatch, SetStateAction } from "react";
import { TCurrentAnalysisTab } from "./DisplayAnalysisResult";

import DescriptionIcon from "@/assets/icons/DescriptionIcon.svg";
import { CustomButton } from "@/components/ui/Buttons";

type VideoAnalysisTabsProps = {
  currentAnalysisTab: TCurrentAnalysisTab;
  setCurrentAnalysisTab: Dispatch<SetStateAction<TCurrentAnalysisTab>>;
};

const videoAnalysisTabsData = [
  { label: "Story Board", id: "storyBoard", icon: <DescriptionIcon /> },
  { label: "Graphics", id: "graphics", icon: <DescriptionIcon /> },
  { label: "Technical", id: "technical", icon: <DescriptionIcon /> },
  { label: "Scenes", id: "scenes", icon: <DescriptionIcon /> },
];

const VideoAnalysisTabs = ({
  currentAnalysisTab,
  setCurrentAnalysisTab,
}: VideoAnalysisTabsProps) => {
  return (
    <div className="mt-5 flex gap-x-4 gap-y-2 flex-wrap">
      {videoAnalysisTabsData.map((tab) => (
        <CustomButton
          onClick={() => setCurrentAnalysisTab(tab.id as TCurrentAnalysisTab)}
          backgroundColor={
            currentAnalysisTab === tab.id ? "#1B1B1B" : "#F2F4F7"
          }
          color={currentAnalysisTab === tab.id ? "#FFFFFF" : "#788193"}
          padding="2px"
          borderRadius="4px"
          className="flex items-center gap-x-1 whitespace-nowrap transition-all duration-"
        >
          <span>
            <DescriptionIcon />
          </span>
          <span
            className={`text-xs leading-5 tracking-[-2.5%] font-grotesk font-medium `}
          >
            {tab.label}
          </span>
        </CustomButton>
      ))}
    </div>
  );
};

export default VideoAnalysisTabs;
